import { Guid } from '@web/utils';

export class AdminOrderItemAttribute {
  public constructor(
    private readonly data: {
      id: Guid;
      value: string;
      productAttributeId: Guid;
      productAttributeLabel: string;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get value(): string {
    return this.data.value;
  }

  public get productAttributeId(): Guid {
    return this.data.productAttributeId;
  }

  public get productAttributeLabel(): string {
    return this.data.productAttributeLabel;
  }
}
